import React, { useEffect, useState } from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import EntityIndicatorDialog from '../EntityIndicatorDialog'
import { Divider, Grid2 } from '@mui/material'
import IndicatorHeaderDialog from '../IndicatorHeaderDialog'
import IndicatorTable from '../IndicatorTable'
import { shallowEqual, useSelector } from 'react-redux'
import { getYear } from 'utils/DateUtil'
import { P109_0, VP_119, VP_063, VP_201, VP_232 } from 'rpqs/constants/RpqsConstant'
import { getIndicatorDialogRow, updateIndicatorEntity } from 'rpqs/utils/RPQSUtils'
import { round } from 'lodash'

const DialogP109_0 = ({
    open = false,
    setOpen = () => {},
    title = '',
}) => {
    const {
        managementEntity,
    } = useSelector(store => ({
        managementEntity: store.CollectivityReducer.managementEntity,
    }), shallowEqual)

    const [entityDialog, setEntityDialog] = useState(managementEntity)

    useEffect(() => {
        setEntityDialog(managementEntity)
    }, [managementEntity])

    const year = getYear(entityDialog?.dateEnd)
    const previousYear = year-1
    const currentEntity = entityDialog?.[year]

    const formatedIndicators = [
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_063.code,
            indicatorName: i18n[VP_063.i18n],
            unit: 'm3',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_063.code,
                { ...currentEntity?.[VP_063.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_201.code,
            indicatorName: i18n[VP_201.i18n],
            unit: 'm3',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_201.code,
                { ...currentEntity?.[VP_201.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_232.code,
            indicatorName: i18n[VP_232.i18n],
            unit: 'm3',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_232.code,
                { ...currentEntity?.[VP_232.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_119.code,
            indicatorName: i18n[VP_119.i18n],
            unit: '€HTVA',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_119.code,
                { ...currentEntity?.[VP_119.code], value: parseInt(v) || 0 },
            ))),
        }),
    ]

    const onStatusChange = (status) => {
        setEntityDialog(updateIndicatorEntity(entityDialog, year, P109_0.code, { ...currentEntity?.[P109_0.code], status }))
    }

    const getIndicatorValue = (indicator) => (currentEntity?.[indicator?.code]?.value || 0)

    const calculation = () => {
        const calculatedValue = getIndicatorValue(VP_232) != 0 ? round(getIndicatorValue(VP_119) / getIndicatorValue(VP_232), 3) : 0

        return updateIndicatorEntity(entityDialog, year, P109_0.code, { ...currentEntity?.[P109_0.code], value: calculatedValue })
    }

    return (
        <EntityIndicatorDialog
            open={open}
            setOpen={setOpen}
            title={title}
            hasNote
            entityDialog={entityDialog}
            setEntityDialog={setEntityDialog}
            codeIndicator={P109_0.code}
            calculationOnRegister={calculation}
        >
            <Grid2 container direction={'column'} gap={2}>
                <IndicatorHeaderDialog
                    current={{
                        year,
                        value: managementEntity?.[year]?.[P109_0.code]?.value,
                    }}
                    previous={{
                        year: previousYear,
                        value: managementEntity?.[previousYear]?.[P109_0.code]?.value,
                    }}
                    status={entityDialog?.[year]?.[P109_0.code]?.status}
                    onStatusChange={onStatusChange}
                    unit={'€/m3'}
                />
                <Divider/>
                <IndicatorTable
                    year={year?.toString()}
                    indicators={formatedIndicators}
                />

            </Grid2>
        </EntityIndicatorDialog>
    )
}

DialogP109_0.propTypes = {
    setOpen: PropTypes.func,
    open: PropTypes.bool,
    title: PropTypes.string,
}

export default DialogP109_0
